import { Link } from "react-router-dom";
import { Aperture } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Brand } from "./Brand";

export const Footer = () => {
  const { settings } = useAuth();
  return (
    <footer className="border-t border-white/10 bg-[#07070B]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-2">
            <Aperture className="h-6 w-6 text-lime-400" />
            <Brand name={settings?.site_name || "D+Photo"} className="text-xl" />
          </div>
          <p className="mt-3 max-w-xs text-sm text-slate-400">{settings?.tagline}</p>
        </div>
        <div className="flex flex-col gap-2 text-sm text-slate-400">
          <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-cyan-400">Navegação</span>
          <Link to="/galeria" className="hover:text-white">Galeria esportiva</Link>
          <Link to="/concursos" className="hover:text-white">Concursos</Link>
          <Link to="/cadastro" className="hover:text-white">Cadastro com 1 foto grátis</Link>
        </div>
        <div className="flex flex-col gap-2 text-sm text-slate-400">
          <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-cyan-400">Contato</span>
          <span data-testid="footer-contact-email">{settings?.contact_email}</span>
          <span className="font-mono-tech text-xs text-slate-500">Pagamentos via Stripe e Mercado Pago</span>
        </div>
      </div>
    </footer>
  );
};
